/**
 * 站点色板。取色基准是公司 logo 的三个颜色：
 *   天蓝 #30b4fc、正红 #d81824、黑 #000000
 *
 * logo 中没有紫色，因此原模板自带的深紫 #2e186a / #18216d 全部替换为
 * 与 logo 天蓝同色相族（约 205°）的深海军蓝，让主色与 logo 属于同一冷色体系。
 * 红色仅作极少量点缀，避免与 UI 中表示错误的语义混淆。
 */
export const colors = {
  /** 主深色：按钮、图标底、深色区块 */
  primary: "#0c2e4e",
  /** 主深色的悬停态，比 primary 亮一档，白字对比度仍有 8:1 */
  primaryHover: "#124b7a",
  /** 标题文字 */
  heading: "#0c2e4e",

  /** 强调色，取自 logo 天蓝。对比度不足，仅用于装饰、边框、图形 */
  accent: "#30b4fc",
  /** 蓝色文字用色，白底对比度 4.6:1，满足 AA */
  accentText: "#1878b8",
  /** 浅蓝底，用于标签 */
  accentSoft: "rgba(48, 180, 252, 0.1)",

  /** logo 正红，只用于装饰性点缀 */
  brandRed: "#d81824",

  /** 正文文字，白底 5.4:1 */
  text: "#54657a",
  /** 次要文字、字段标签 */
  textMuted: "#8496ab",

  /** 边框 */
  border: "#e6edf5",
  /** 浅背景（页脚、输入框） */
  surface: "#f2f6fa",

  /** 卡片阴影 */
  shadow: "0 14px 36px rgba(12, 46, 78, 0.08)",
  shadowHover: "0 20px 44px rgba(12, 46, 78, 0.14)",
};
